"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kanban = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_1 = require("react-router");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const types_1 = require("@framework/types");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_2 = require("../../../types");
const common_1 = require("../../../common");
const order_1 = require("../order");
const board_1 = require("./board");
const ORDERS_URL = {
    [types_2.ServiceType.ADMIN]: "/ecommerce/orders",
    [types_2.ServiceType.OFFICE]: "/orders",
};
const ORDERS_DIALOG_URL = "/orders";
const ORDERS_DIALOG_KEY = "ecommerceOrders";
const Kanban = (props) => {
    const { service } = props;
    const navigate = (0, react_router_1.useNavigate)();
    // TODO - [AFTER ALL REFACTORING] - add possibility to set useQuery options to useFetchQuery
    // TODO - [AFTER ALL REFACTORING] - add refetchInterval 10000
    const { isLoading, allRows, refetch } = (0, react_hooks_1.useFetchQuery)(ORDERS_URL[service], void 0, void 0, {
        orderStatus: [types_1.OrderStatus.NEW, types_1.OrderStatus.SCHEDULED, types_1.OrderStatus.NOW_IN_DELIVERY, types_1.OrderStatus.DELIVERED],
        isArchived: false,
    });
    const { handleForm, mode, selectedItem, formDialogUniqueKey } = (0, react_hooks_1.useDialogForm)();
    const { fn: updateOrderStatusApi } = (0, react_hooks_1.useApiCall)((api, data) => {
        const { id, orderStatus } = data;
        return api.fetchJson({
            url: `/ecommerce/orders/${id}/move`,
            method: "POST",
            data: {
                orderStatus,
            },
        });
    }, { success: false });
    const updateOrderStatus = (id, orderStatus) => {
        return updateOrderStatusApi(void 0, { id, orderStatus });
    };
    const handleEdit = (order) => {
        handleForm(ORDERS_DIALOG_KEY, order, "edit");
        void navigate(`/ecommerce/kanban/${order.id}`);
    };
    const handleCreate = () => {
        handleForm(ORDERS_DIALOG_KEY, common_1.emptyOrder, "create");
    };
    const handleOrderStatusChange = async (id, orderStatus) => {
        await updateOrderStatus(id, orderStatus);
        await refetch();
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "ecommerce", "kanban"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.kanban.title", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), onClick: handleCreate, "data-testid": "EcommerceOrderCreateButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.create" }) }) }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(board_1.Board, { initial: (0, order_1.groupOrdersByStatus)(allRows), onOrderStatusChange: handleOrderStatusChange, onEdit: handleEdit }) }), (0, jsx_runtime_1.jsx)(order_1.OrderDialogForm, { url: ORDERS_DIALOG_URL, open: formDialogUniqueKey === `${ORDERS_DIALOG_KEY}.${mode}`, mode: mode, selectedItem: selectedItem, refetch: refetch })] }));
};
exports.Kanban = Kanban;
//# sourceMappingURL=index.js.map